import { Home } from '@mui/icons-material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Link } from '@ovComponents/2-component/orgLink/orgLink';
import { legacyColors } from '@ovComponents/legacyColor';
import { Typography } from 'hephaestus/web';
import { useContext } from 'react';
import './breadcrumbs.css';
import { UserContext } from '@providers/userContextProvider';

type BreadcrumbItem = {
  href: string;
  label: string | React.FunctionComponent;
  testId?: string;
};
export type BreadcrumbsProps = {
  items: BreadcrumbItem[];
  overrideColor?: string;
};

export function Breadcrumbs({ items, overrideColor }: BreadcrumbsProps) {
  const { userContext } = useContext(UserContext);
  let homeItem: any = null;
  if (userContext.role?.navigationStyle === 'SIMPLE') {
    const clientItems = items.splice(0, 2);

    homeItem = clientItems[1];
  }
  if (items.length === 0) {
    return <></>;
  }
  return (
    <div>
      {homeItem && (
        <>
          <Link
            to={homeItem.href}
            className='breadcrumb-link'
            style={{ color: legacyColors.neutral600 }}
            data-testid='home-breadcrumb-link'
          >
            <Home
              sx={{
                fontSize: '20px',
                color: overrideColor ?? legacyColors.neutral600,
                marginBottom: '-3px',
              }}
            />
          </Link>
          <ChevronRightIcon
            style={{ color: overrideColor || legacyColors.neutral600 }}
            sx={{ height: '18px', marginBottom: '-3px' }}
          />
        </>
      )}
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <span key={index}>
            <Typography
              variant='bodyLarge'
              component='span'
              sx={{
                fontWeight: isLast ? 600 : 500,
                lineHeight: '20px',
              }}
            >
              <SmartBreadcrumb
                key={index}
                href={item.href}
                TheLabel={item.label}
                color={
                  overrideColor ||
                  (isLast ? legacyColors.neutral700 : legacyColors.neutral600)
                }
                testId={item.testId}
              />
            </Typography>
            {isLast || (
              <ChevronRightIcon
                style={{ color: overrideColor || legacyColors.neutral600 }}
                sx={{ height: '18px', marginBottom: '-3px' }}
              />
            )}
          </span>
        );
      })}
    </div>
  );
}

function SmartBreadcrumb({
  href,
  TheLabel,
  color,
  testId,
}: {
  href: string;
  TheLabel: string | React.FunctionComponent;
  color: string;
  testId?: string;
}) {
  return (
    <Link
      to={href}
      className='breadcrumb-link'
      style={{ color }}
      data-testid={testId ?? 'breadcrumb-link'}
    >
      {typeof TheLabel === 'function' ? <TheLabel /> : TheLabel}
    </Link>
  );
}
